module.exports = __webpack_public_path__ + "static/media/language-min.3ce79f64.jpg";